export default {
  titleOfCriteria: "Criterios para la Selección de Activos",
  performance: "Rendimiento",
  commissioningDate: "Fecha de Puesta en Servicio",
  enterdate: "Por favor ingrese una fecha",
  selectedAssetsPreview: "Vista Previa de Activos Seleccionados",
  descriptionOfSelectedAssets: "Defina primero los criterios para la selección de activos para ver su vista previa",
  descriptionOfCriteria:
    "Defina los criterios para identificar los activos relevantes para este aviso de seguridad. Se pueden incluir múltiples modelos de activos. Puede previsualizar instancias de los modelos seleccionados en el lado derecho de esta página.",
  selectValidForm: "Por favor seleccione un formulario válido",
  selectTitle: "Por favor ingrese un título",
  invalidURL: "URL inválida",
  selectAsset: "Seleccionar Activo",
  startDate: "Fecha de Inicio",
  endDate: "Fecha de Finalización",
  until: "hasta",
  validFrom: "Válido desde",
  portalLink: "Enlace del Portal",
  relatedModels: "Modelos Relacionados",
  file: "Archivo",
};
